import React from 'react';
import {Badge, IconButton, Tooltip, useMediaQuery} from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {useNavigate} from 'react-router-dom';

const NavBarAdminActionableTrades = () => {
    const navigate = useNavigate();
    const isSmUp = useMediaQuery('(min-width:640px)');
    const actionableTrades = useSelector((state: RootState) => state.admin.actionableTrades || 0);

    if (actionableTrades === 0 || !isSmUp) {
        return null;
    }

    return (
        <Tooltip title="Actionable Trades">
            <IconButton
                onClick={() => navigate('/admin/trades')}
                size="medium"
                sx={{
                    height: 40,
                    width: 40,
                    color: 'warning.contrastText',
                    backgroundColor: 'warning.main',
                    border: '1px solid',
                    borderColor: 'warning.main',
                    borderRadius: '8px',
                    '&:hover': {
                        backgroundColor: 'warning.main',
                    },
                }}
            >
                <Badge badgeContent={actionableTrades > 99 ? '99+' : actionableTrades} color="error">
                    <SwapHorizIcon />
                </Badge>
            </IconButton>
        </Tooltip>
    );
};

export default NavBarAdminActionableTrades;